import * as React from 'react';

import { TNotificationType } from '../../types';
import { NotificationLayout } from '../NotificationLayout';
import { NotificationItem } from '../NotificationItem';

export interface ISimpleNotificationProps {
  type?: TNotificationType;
  title?: string;
  icon?: React.ReactNode;
  message?: React.ReactNode;
  actions?: React.ReactElement;
  testId?: string;
}

export const SimpleNotification: React.FC<ISimpleNotificationProps> = props => {
  const { icon, title, message, actions, testId, type = 'info' } = props;

  return (
    <NotificationLayout type={type} testId={testId}>
      <NotificationItem title={title} message={message} icon={icon} actions={actions} type={type} />
    </NotificationLayout>
  );
};
